import { useNavigate } from 'react-router-dom';
import { toast } from 'sonner';

const RED = '#b91d47', RED_D = '#8f1538', INK = '#1c1c28', GREY = '#7a7a8c';

const OFFERS = [
  { code: 'FIRST30', title: '30% OFF on first booking', desc: 'New users only. Max ₹100 off.', color: 'linear-gradient(135deg,#b91d47,#8f1538)' },
  { code: 'WEEKEND20', title: '20% OFF this weekend', desc: 'Valid on Saturday & Sunday.', color: 'linear-gradient(135deg,#7c3aed,#4c1d95)' },
  { code: 'GROOM50', title: 'Flat ₹50 OFF on grooming', desc: 'On bookings above ₹200.', color: 'linear-gradient(135deg,#0891b2,#065f66)' },
];

export default function AppOffers() {
  const navigate = useNavigate();

  const copy = (code) => {
    try { navigator.clipboard.writeText(code); } catch (e) {}
    toast.success(`Code ${code} copied!`);
  };

  return (
    <div style={{ minHeight: '100vh', background: '#f4f6fb', maxWidth: 480, margin: '0 auto' }}>
      <div style={{ background: `linear-gradient(135deg,${RED},${RED_D})`, color: '#fff', padding: '20px 16px', display: 'flex', alignItems: 'center', gap: 14 }}>
        <span onClick={() => navigate('/app/profile')} style={{ fontSize: 24, cursor: 'pointer' }}>‹</span>
        <div style={{ fontSize: 18, fontWeight: 700 }}>Offers & Coupons</div>
      </div>
      <div style={{ padding: 16 }}>
        {OFFERS.map((o, i) => (
          <div key={i} style={{ background: o.color, borderRadius: 16, padding: 18, marginBottom: 14, color: '#fff', position: 'relative', overflow: 'hidden' }}>
            <div style={{ fontSize: 17, fontWeight: 800 }}>{o.title}</div>
            <div style={{ fontSize: 12, opacity: 0.9, marginTop: 4 }}>{o.desc}</div>
            <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginTop: 14 }}>
              <div style={{ border: '1.5px dashed rgba(255,255,255,.6)', borderRadius: 8, padding: '8px 14px', fontWeight: 800, letterSpacing: 1, fontSize: 14 }}>{o.code}</div>
              <button onClick={() => copy(o.code)} style={{ background: '#fff', color: INK, border: 'none', borderRadius: 8, padding: '9px 16px', fontWeight: 700, fontSize: 13, cursor: 'pointer' }}>Copy</button>
            </div>
          </div>
        ))}
        <div style={{ textAlign: 'center', fontSize: 12, color: GREY, marginTop: 8 }}>Apply these codes at checkout.</div>
      </div>
    </div>
  );
}
